import React, { useEffect } from 'react';

import useCookie from '@utils/customsHook/useCookie';

const XP_PROFILE_COOKIE_KEY_VALUE = 'XPProfileId';

const XPProfileHandler = () => {
  const cookie = useCookie();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const xpProfileIdValue = cookie.get(XP_PROFILE_COOKIE_KEY_VALUE);
      if (xpProfileIdValue) {
        const xpProfileFromLocalStorage = window.localStorage.getItem(XP_PROFILE_COOKIE_KEY_VALUE);
        if (xpProfileFromLocalStorage !== xpProfileIdValue) window.localStorage.setItem(XP_PROFILE_COOKIE_KEY_VALUE, xpProfileIdValue);
      } else {
        window.localStorage.removeItem(XP_PROFILE_COOKIE_KEY_VALUE);
      }
    }
  }, [cookie]);

  return <></>;
};

export default XPProfileHandler;